import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"

// Semantic UI container widths (approx):
// tablet: 723px, computer: 933px, large-screen: 1127px+
const MAX_WIDTHS = {
  mobile: "100%",
  tablet: "723px",
  computer: "933px",
  "large-screen": "1127px",
  widescreen: "1127px",
}

function Container({ children, maxSize, className, style, ...rest }) {
  const containerStyle = {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    ...(maxSize && maxSize !== "mobile"
      ? { maxWidth: MAX_WIDTHS[maxSize] }
      : {}),
    ...style,
  }

  return (
    <div
      className={cx("container", className)}
      style={containerStyle}
      {...rest}
    >
      {children}
    </div>
  )
}

Container.propTypes = {
  children: PropTypes.node,
  maxSize: PropTypes.oneOf([
    "mobile",
    "tablet",
    "computer",
    "large-screen",
    "widescreen",
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Container
